import React from "react";

function Footer() {
    return null;
}

export default Footer;